import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Maximize2 } from 'lucide-react';
import { ExpandModal } from '../ui/ExpandModal';
import { SideBarChart } from '../ui/SideBarChart';
import { SupplierSpending } from '../../utils/orderHistoryCalculations';

interface SpendBySupplierCardProps {
  data: SupplierSpending[];
}

/**
 * All-restaurants "Spend by supplier" card: reuses {@link SideBarChart} (supplier logos +
 * proportional bars) for the compact card (top 8) and renders the full set inside an
 * ExpandModal on maximize. Handles `any_invoice` + `unknownSupplierName` via SideBarChart.
 */
export const SpendBySupplierCard: React.FC<SpendBySupplierCardProps> = ({ data }) => {
  const { t } = useTranslation();
  const [maximized, setMaximized] = useState(false);

  const maximizeButton = (
    <button
      type="button"
      onClick={() => setMaximized(true)}
      title={t('dashboard.maximize')}
      aria-label={t('dashboard.maximize')}
      className="p-1.5 rounded-md text-textSecondary dark:text-textSecondary-dark hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
    >
      <Maximize2 className="w-4 h-4" />
    </button>
  );

  return (
    <>
      <SideBarChart
        data={data}
        title={t('orderHistory.spendBySupplier')}
        headerActionsRight={maximizeButton}
      />

      <ExpandModal
        isOpen={maximized}
        onClose={() => setMaximized(false)}
        title={t('orderHistory.spendBySupplier')}
        maxWidth="max-w-2xl"
      >
        {/* Empty title suppresses SideBarChart's own header; the modal shows the title. */}
        <SideBarChart data={data} title="" maxItems={1000} />
      </ExpandModal>
    </>
  );
};

export default SpendBySupplierCard;
